<div class="field has-addons">
  <div class="control">
    <input
      type="date"
      class="input"
      [value]="selectedDate"
      [placeholder]="Placeholder"
      [title]="Placeholder"
      (change)="onDateChange($event)">
    </div>
    @if (selectedDate) {
      <div class="control">
        <button class="button" (click)="clearDate()" type="button" title="Clear date filter">
          <span class="icon">
            <i class="fas fa-times"></i>
          </span>
        </button>
      </div>
    }
  </div>

